import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface TextColumnProps extends PropsWithChildren {}

const TextColumn: FC<TextColumnProps> = ({ children }) => {
  return <Column>{children}</Column>;
};

export default TextColumn;

const Column = styled.div`
  ${customTextSize(14, 20)};
  padding: 0 30px;
  text-align: var(--text-columns-text-alignment, left);

  display: flex;
  flex-direction: column;
  gap: ${remCalc(15)};

  a {
    text-decoration: underline;
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  }

  ${mediaBreakpointUp('tablet')} {
    flex-grow: 1;
    flex-shrink: 0;
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(18, 26)};
  }
`;

export const TextColumnHeading = styled.h6`
  ${customTextSize(16, 20)};
  font-weight: ${FONT_WEIGHTS.BOLD};

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(24, 34)};
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  }
`;
